import React, { Component } from "react";

class Label extends Component {
  required() {
    var required = null;
    if (this.props.required) {
      required = (
        <span aria-describedby="required-description" className="text-danger">*</span>
      )
    }
    return required;
  }

  render() {
    return (
      <span className="label">
        {this.props.name}
        {this.required()}
      </span>
    );
  }
}
export default Label;